// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__-sDGE","inputWrap":"CustomTip_inputWrap__3GKph"};